import { MenuId } from '../types';

export const HIDE_ALL = 0;
export const DISPLAY_MENU = (id: MenuId) => `DISPLAY_${id}`;
